export class CardObject {
    isSaveCardDetails: boolean = false;
    cardNumber?: string;
    cardExpirationMonth?: number;
    cardExpirationYear?: number;
    cardCvv?: string;
    cardOwnerName?: string;
    isTermsConditionAccepted: boolean = false;
}
